import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";
import {CmsPage} from "@/models";

export class CmsPageService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {        
    }

    public GetCmsPage(query: {
        lang_code: string,
        store_view: number,
        page_type: string
    }) {
        return this.baseApiFactory.getData<CmsPage>('/api/CMSPage', query);
    }

    public UpdatePage(value: CmsPage) {
        return this.baseApiFactory.put<boolean>('/api/CMSPage', value);
    }
}

lazyRegister.service('CmsPageService', CmsPageService);
